import React from 'react';
import cx from '../../../../utils/cx';
import Scrollbar from '../../components/Scrollbar';
import { NFTTabsContainer, NFTTabsContent, NFTTabsHeader } from './styled';


export interface ITabItem {
    key: string;
    name: string;
}

interface INFTTabsProps {
    tabs: ITabItem[];
    noHeader?: boolean;
    noScrollbar?: boolean;
    activeTab?: string;
    renderTabContent: (key: string) => any;
}

const NFTTabs = (props: INFTTabsProps) => {

    const [activeTab, setActiveTab] = React.useState(props.activeTab ?? (props.tabs.length > 0 ? props.tabs[0].key : ''));

    React.useEffect(() => {
        props.activeTab && setActiveTab(props.activeTab);
    }, [props.activeTab])

    const handleTabClick = (key: string) => {
        setActiveTab(key);
    }

    const renderTabHeaderItems = () => {
        return props.tabs.map((tab: ITabItem, index: number) => {
            return (<span key={tab.key} className={tab.key == activeTab ? "active" : ""} onClick={() => { handleTabClick(tab.key) }}>{tab.name}</span>)
        });
    }

    const renderTabContent = () => {
        if (props.noScrollbar) {
            return props.renderTabContent(activeTab);
        } else {
            return (
                <Scrollbar>
                    {props.renderTabContent(activeTab)}
                </Scrollbar>
            )
        }
    }

    return (
        <NFTTabsContainer>
            {!props.noHeader &&
                <NFTTabsHeader>
                    {renderTabHeaderItems()}
                </NFTTabsHeader>
            }
            <NFTTabsContent className={cx({ noHeader: props.noHeader })}>
                {renderTabContent()}
            </NFTTabsContent>
        </NFTTabsContainer>
    )
}

export default NFTTabs;